exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selWidth[data-v-5935094d] {\r\n  width: 90%;\n}\n.btndel[data-v-5935094d] {\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  left: 46px;\r\n  top: -4px;\n}\r\n", ""]);

// exports
